export var formatDisplayTime = function formatDisplayTime(time) {
  return time.replace(/^0/, '');
};